import { render, staticRenderFns } from "./ReserveReceiversEditor.vue?vue&type=template&id=2485b48c&scoped=true"
import script from "./ReserveReceiversEditor.vue?vue&type=script&lang=js"
export * from "./ReserveReceiversEditor.vue?vue&type=script&lang=js"
import style0 from "./ReserveReceiversEditor.vue?vue&type=style&index=0&id=2485b48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2485b48c",
  null
  
)

export default component.exports